import React from 'react';
import { ResponsiveContainer, AreaChart, Area, CartesianGrid, XAxis, YAxis, Tooltip, Line, ComposedChart } from 'recharts';
import { Download } from 'lucide-react';
import { Widget } from './Widget';
const DATA = Array.from({
  length: 30
}, (_, i) => {
  const day = i + 1;
  const base = 700 + Math.sin(i / 3) * 90 + (i > 18 ? 80 : 0);
  const noise = i * 37 % 60;
  const shipments = Math.round(base + noise);
  const rate = +(94.5 + Math.sin(i / 4) * 1.2 + (i > 14 ? 0.8 : 0) + (i % 5 === 0 ? -0.3 : 0)).toFixed(1);
  return {
    day: `${day}`,
    label: `${day} apr`,
    shipments,
    rate
  };
});
function CustomTooltip({
  active,
  payload,
  label
}: any) {
  if (!active || !payload?.length) return null;
  return <div className="bg-[#0A0A0A] border border-[#2A2A2A] rounded-lg px-3 py-2 text-xs shadow-xl" data-id="element-3891">
      <div className="text-[#9A9A9A] mb-1" data-id="element-3892">{label} aprile</div>
      <div className="flex items-center gap-2 text-[#FAFAFA] font-mono" data-id="element-3893">
        <span className="h-2 w-2 rounded-full bg-[#D4FF3A]" data-id="element-3894" />
        {payload[0]?.value?.toLocaleString('it-IT')} spedizioni
      </div>
      {payload[1] && <div className="flex items-center gap-2 text-[#FAFAFA] font-mono mt-0.5" data-id="element-3895">
          <span className="h-2 w-2 rounded-full bg-[#9A9A9A]" data-id="element-3896" />
          {payload[1].value}% consegnate
        </div>}
    </div>;
}
type Props = {
  onViewReport?: () => void;
};
export function ShipmentsChart({
  onViewReport
}: Props = {}) {
  return <Widget title="Andamento spedizioni ai negozi" headerRight={<>
          <div className="hidden sm:flex items-center gap-4 text-xs" data-id="element-3898">
            <div className="flex items-center gap-1.5 text-[#9A9A9A]" data-id="element-3899">
              <span className="h-2 w-2 rounded-full bg-[#D4FF3A]" data-id="element-3900" />
              <span data-id="element-3901">Spedizioni</span>
            </div>
            <div className="flex items-center gap-1.5 text-[#9A9A9A]" data-id="element-3902">
              <span className="h-2 w-2 rounded-full bg-[#6B6B6B]" data-id="element-3903" />
              <span data-id="element-3904">Tasso di consegna</span>
            </div>
          </div>
          <button type="button" className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-[#0A0A0A] border border-[#262626] text-xs font-medium text-[#FAFAFA] hover:border-[#333] transition" data-id="element-3905">
            <Download className="h-3.5 w-3.5" data-id="element-3906" />
            Esporta
          </button>
        </>} footerCta={{
    label: 'Vedi report dettagliato',
    onClick: onViewReport
  }} data-id="element-3897">
      <div className="h-[280px] w-full" data-id="element-3907">
        <ResponsiveContainer width="100%" height="100%" data-id="element-3908">
          <ComposedChart data={DATA} margin={{
          top: 8,
          right: 8,
          left: 0,
          bottom: 0
        }} data-id="element-3909">
            <defs data-id="element-3910">
              <linearGradient id="ship-fill" x1="0" y1="0" x2="0" y2="1" data-id="element-3911">
                <stop offset="0%" stopColor="#D4FF3A" stopOpacity={0.18} data-id="element-3912" />
                <stop offset="100%" stopColor="#D4FF3A" stopOpacity={0} data-id="element-3913" />
              </linearGradient>
            </defs>
            <CartesianGrid stroke="#222" vertical={false} data-id="element-3914" />
            <XAxis dataKey="day" stroke="#6B6B6B" fontSize={11} tickLine={false} axisLine={false} interval={3} data-id="element-3915" />
            <YAxis yAxisId="left" stroke="#6B6B6B" fontSize={11} tickLine={false} axisLine={false} width={42} data-id="element-3916" />
            <YAxis yAxisId="right" orientation="right" stroke="#6B6B6B" fontSize={11} tickLine={false} axisLine={false} domain={[90, 100]} width={36} tickFormatter={v => `${v}%`} data-id="element-3917" />
            <Tooltip content={<CustomTooltip data-id="element-3919" />} cursor={{
            stroke: '#2A2A2A',
            strokeWidth: 1
          }} data-id="element-3918" />
            <Area yAxisId="left" type="monotone" dataKey="shipments" stroke="#D4FF3A" strokeWidth={2} fill="url(#ship-fill)" isAnimationActive={false} data-id="element-3920" />
            <Line yAxisId="right" type="monotone" dataKey="rate" stroke="#9A9A9A" strokeWidth={1.5} strokeDasharray="3 3" dot={false} isAnimationActive={false} data-id="element-3921" />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </Widget>;
}